//@ts-checks
import { createApp } from "vue";
import Fuse from 'fuse.js'
import $ from "jquery"
import flatpickrVue from 'vue-flatpickr-component';
//
import { dropzoneVue } from './composant/dropezoneVue'

import { FilterCheckbox, FilterEmpty } from './composant/FilterV0';
//
import { flatPickrConfig } from "./composant/b2bLangue";
import htmlNew from "./linelistEdit.html";
//
//
import { DateHelper } from "../B2bTools";

import Store from "../Store";

function filterCheckboxLabel() {
	const checked = this.param.valeur.checked;
	return this.v + ((checked && checked.length) ? " (" + checked.length + ")" : "")
}
const jsNew = ({
	url: function (echangeur) {
		 
      
        
        if(!echangeur.hash.env) {
			let u = Store.get('getURUL')();
			echangeur.hash.u= u;
		}
		// echangeur.hash.env
		echangeur.addAction('b2b.codification.select', { classe: "productdepartment" }, '', 'department');
		echangeur.addAction('b2b.codification.select', { classe: "collectiontype" }, '', 'collectiontype');
		echangeur.addAction('b2b.codification.select', { classe: "macrofamily" }, '', 'macrofamily');
		echangeur.addAction('b2b.codification.select', { classe: "family" }, '', 'family');
		echangeur.addAction('b2b.codification.select', { classe: "linelisttri" }, '', 'linelisttri');
		//
		echangeur.addAction('b2b.toc.list', echangeur.hash, '', 'toc');
		echangeur.addAction('b2b.linelist.edit', echangeur.hash, '', 'form');
		echangeur.addAction('b2b.linelist.groups', echangeur.hash, 'form', 'groups');
	},
	onLoad: async function (echangeur) {
		//
		echangeur.press = { rows: [{ k: "true", v: "Press" }, { k: "false", v: "No press" }] };
		echangeur.exclus = { rows: [{ k: "true", v: "Exclusivity" }, { k: "false", v: "No exclusivity" }] };
		//
		let THIS = this;
		const env = echangeur.hash.env;
		//
		const defaultsaisie = echangeur.form;

		//
		// pour vue  
		// Etape 2 : Select categories to filter
		// initialiser les etats pour la sélection des filtres
		// 
		// etat 0 => pas encore dispo 
		// etat 1 => en cours de selection
		// etat 2 => sélectioné 
		//

		let dataFiltre = [];
		const optionsFuses = { includeScore: false, minMatchCharLength: 2, threshold: 0.2, keys: ['v'] };

		const fuse = new Fuse(dataFiltre, optionsFuses);

		// options.keys

		const app = createApp({
			components: {
				'filter-checkbox': FilterCheckbox,
				'filter-empty': FilterEmpty,
				'dropzone-vue': dropzoneVue,
				'flatpickr-vue': flatpickrVue
			},

			data: function () {
				// ici on complète le formulaire avec les champs nécessaire à vue.js non retourné par b2b.linelist.edit
				if (!defaultsaisie.filtre.department) defaultsaisie.filtre.department = { checked: [] };
				// 
				//
				if (!defaultsaisie.filtre.deliverytheme) defaultsaisie.filtre.deliverytheme = { checked: [] };
				//
				//
				if (!defaultsaisie.filtre.collectiontype) defaultsaisie.filtre.collectiontype = { checked: [] };
				if (!defaultsaisie.filtre.collectiongroup) defaultsaisie.filtre.collectiongroup = { checked: [] };
				// 
				if (!defaultsaisie.filtre.macrofamily) defaultsaisie.filtre.macrofamily = { checked: [] };
				if (!defaultsaisie.filtre.family) defaultsaisie.filtre.family = { checked: [] };
				//
				if (!defaultsaisie.filtre.press) defaultsaisie.filtre.press = { checked: [] };
				if (!defaultsaisie.filtre.exclus) defaultsaisie.filtre.exclus = { checked: [] };
				//
				if (!defaultsaisie.filtre.matprin) defaultsaisie.filtre.matprin = { checked: [] };
				if (!defaultsaisie.filtre.embellishment) defaultsaisie.filtre.embellishment = { checked: [] };
				if (!defaultsaisie.filtre.guideline) defaultsaisie.filtre.guideline = { checked: [] };
				if (!defaultsaisie.filtre.line) defaultsaisie.filtre.line = { checked: [] };
				//


				//
				// images à traiter lors de la sauvegarde du document.
				defaultsaisie.$batchImg = {};
				//
				function imgUrl(form, laquelle) {
					if (form.visuel && form.visuel[laquelle]) {
						let img = form.visuel[laquelle];
						if (img.length < 30) img = form._id + "_" + img	///@douteux
						return "image/linelist/" + img;
					}
				}
				//

				const filters = [
					{
						k: "department", v: "Department",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						param: {
							titre: "Select product department to filter",
							liste: echangeur.department.rows,
							valeur: defaultsaisie.filtre.department,
						},
					},
					{
						k: "deliverytheme", v: "Delivery Theme",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "deliverytheme" }, saisie)
							filterparam.liste = array;
						},
						param: {
							titre: "Select Delivery Theme to filter",
							liste: [],
							valeur: defaultsaisie.filtre.deliverytheme,
						},
					},
					{
						k: "collectiongroup", v: "Collection group",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "collectiongroup" }, saisie)
							filterparam.liste = array;
						},
						param: {
							titre: "Select collection type group to filter",
							liste: [],
							valeur: defaultsaisie.filtre.collectiongroup
						}
					},
					{
						k: "collectiontype", v: "Collection type",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						param: {
							titre: "Select collection type to filter",
							liste: echangeur.collectiontype.rows,
							valeur: defaultsaisie.filtre.collectiontype
						}
					},
					{
						k: "macrofamily", v: "Macro family",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "macrofamily" }, saisie)
							filterparam.liste = array;
						},
						param: {
							titre: "Select Macro family to filter",
							liste: echangeur.macrofamily.rows,
							valeur: defaultsaisie.filtre.macrofamily
						}
					},
					{
						k: "family", v: "Family",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const kvs = await THIS.rest("b2b.linelist.drops", { classe: "family" }, saisie);
							const ks = kvs.map(u => u.k);
							//
							const source = echangeur.family.rows;
							filterparam.liste = source.filter(u => (ks.indexOf(u.k)) >= 0);
						},
						param: {
							titre: "Select Family to filter",
							liste: echangeur.family.rows,
							valeur: defaultsaisie.filtre.family
						}
					},

					{
						k: "press", v: "Press Edito",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						param: {
							titre: "Select Press edito to filter",
							liste: echangeur.press.rows,
							valeur: defaultsaisie.filtre.press
						}
					},
					{
						k: "press", v: "Exclusivity",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						param: {
							titre: "Select Exclusivity to filter",
							liste: echangeur.exclus.rows,
							valeur: defaultsaisie.filtre.exclus
						}
					},
					{
						k: "matprin", v: "Main material",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "matprin" }, saisie);
							filterparam.liste = array;
						},
						param: {
							titre: "Select Main material to filter",
							liste: [],
							valeur: defaultsaisie.filtre.matprin
						}
					},
					{
						k: "embellishment", v: "Embellishment",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "embellishment" }, saisie);
							filterparam.liste = array;
						},
						param: {
							titre: "Select Embellishment to filter",
							liste: [],
							valeur: defaultsaisie.filtre.embellishment
						}
					},
					{
						k: "guideline", v: "Buying guideline",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "guideline" }, saisie);
							filterparam.liste = array;
						},
						param: {
							titre: "Select Buying guideline to filter",
							liste: [],
							valeur: defaultsaisie.filtre.guideline
						}
					},
					{
						k: "line", v: "Line",
						is: 'filter-checkbox',
						label: filterCheckboxLabel,
						beforeShow: async function (filterparam, saisie) {
							const array = await THIS.rest("b2b.linelist.drops", { classe: "line" }, saisie);
							filterparam.liste = array;
						},
						param: {
							titre: "Select Line to filter",
							liste: [],
							valeur: defaultsaisie.filtre.line
						}
					},
				]




				return {
					dateDeb: null,
					etape: 1,
					isEdition: false,
					//
					codification: {
						toc: { options: echangeur.toc.rows },
						linelisttri: { options: echangeur.linelisttri.rows },
						section: { options: [] },
						regroupment: {
							options: [
								{ k: 'department', v: 'Department' },
								{ k: 'deliverytheme', v: 'Delivery theme' },
								{ k: 'collectiongroup', v: 'Collection type Group' },
								{ k: 'collectiontype', v: 'Collection type' },
								{ k: 'line', v: 'Line' },
								{ k: 'macrofamily', v: 'Macro family' },
								{ k: 'family', v: 'Family' },
								{ k: 'haut', v: 'Heel height' },
							]
						},
						groups: echangeur.groups.rows,
						filters,
					},

					//
					saisie: defaultsaisie,

					error: {
						publishDate: null,
						error: null,
					},

					publishDate: null,

					composantfilter: {		// interface avec le composant filter en page 2
						is: 'filter-empty',
						param: {},
					},
					// composantDate: {		// interface avec le composant filter en page 2
					// 	is: 'flatpickr-vue',
					// 	param: {},// lng: 'fr' 

					// },
					dropzoneFront: {
						original: imgUrl(defaultsaisie, "front"),
					},

					dropzoneReg1: {
						original: imgUrl(defaultsaisie, "reg1"),
					},

					dropzoneBanner: {
						original: imgUrl(defaultsaisie, "banner"),
					},

					//dropzoneReg2: {
					//	original: imgUrl(defaultsaisie, "reg2"),
					//},
					//
					searchUser: { k: null, result: [] },
					//
					//
					groupeUsers: [],


					/* Etape 2*/
					searchFiltre: { k: null, result: [] },
					filtersSelected: { k: null, rows: [], search: [] },
					filterCapsule: [],
					selectFiltersError: null,


					/* Etape 3*/
					refs: [],
					refsChecked: [],
					totalRefsSelected: 0,
					onlyRefsChecked: false,
					searchProduct: { k: '', result: [] },
					fuseProduct: null,
					selectRefsError: null,
					flatPickrConfig: flatPickrConfig,
				}
			},
			computed: {
				construitCapsule: function () {
					function construitCapsuleUn(Nom, liste, valeur) {
						const retour = { v: Nom, rows: [] };
						if (valeur.checked && valeur.checked.length) {
							for (const k of valeur.checked) {
								const item = liste.find(u => (k === u.k));
								retour.rows.push({ val: true, v: (item && item.v) ? item.v : k });
							}
						}
						return retour;
					}
					const array = [

						construitCapsuleUn("Department", echangeur.department.rows, this.saisie.filtre.department),
						//
						construitCapsuleUn("Delivery theme", [], this.saisie.filtre.deliverytheme),
						construitCapsuleUn("Collection group", [], this.saisie.filtre.collectiongroup),
						construitCapsuleUn("Collection type", echangeur.collectiontype.rows, this.saisie.filtre.collectiontype),
						construitCapsuleUn("Macro Family", echangeur.macrofamily.rows, this.saisie.filtre.macrofamily),
						construitCapsuleUn("Family", echangeur.family.rows, this.saisie.filtre.family),

						construitCapsuleUn("Main material", [], this.saisie.filtre.matprin),
						construitCapsuleUn("Embellishment", [], this.saisie.filtre.embellishment),
						construitCapsuleUn("Buying guideline", [], this.saisie.filtre.guideline),
						construitCapsuleUn("Line", [], this.saisie.filtre.line),

						construitCapsuleUn("Press edito", echangeur.press.rows, this.saisie.filtre.press),
						construitCapsuleUn("Exclusivity", echangeur.exclus.rows, this.saisie.filtre.exclus),
					].filter(u => (u.rows.length > 0));
					//
					return array;
				},
			},
			methods: {
				cancel() {
					THIS.fin();
				},

				/* 				isEdition: function () {
									return (this.edit.etape1 || this.edit.etape2 || this.edit.etape3 || this.edit.etape4);
								}, */

				back() {
					this.etape = parseInt(this.etape) - 1;
					$('._etape' + this.etape)[0].scrollIntoView()
				},
				async tocChange() {

					if (this.saisie.tocK) {
						const A = await THIS.rest("b2b.toc.getSections", { k: this.saisie.tocK, env:env });
						this.codification.section.options = A.rows;
					}
				},
				toDate: function (a) {
					return DateHelper.toDate(a);
				},
				toSection(k) {
					const option = this.codification.section.options.find(u => (u.k == k));
					return (option) ? option.v : k;
				},

				getDate: function (date) {
					this.$refs.dateDeb.set(this.saisie.publishDate.start);
				},
				setImgFront: function (tempname) {
					this.saisie.$batchImg.front = tempname;
				},
				setImgBanner: function (tempname) {
					this.saisie.$batchImg.banner = tempname;
				},
				setImgReg1: function (tempname) {
					this.saisie.$batchImg.reg1 = tempname;
				},
				next: function () {

					if (this.etape == 1 && this.etape1IsValid()) {
						this.etape = 2
						$('._etape2')[0].scrollIntoView()
					}

					else if (this.etape == 2 && this.etape2IsValid()) {
						this.etape = 4
						$('._etape4')[0].scrollIntoView()
					}

					// else if (this.etape == 3 && this.etape3IsValid()) {
					// 	this.etape = this.etape + 1

					// 	$('body').scrollTo( $('._etape4')[0]) ;
					// 	// $('._etape4')[0].scrollIntoView()
					// }
					else if (this.etape == 4 && this.etape4IsValid()) this.etape = this.etape;


				},

				editEtape(e) {
					this.isEdition = true;
					this.etape = Number.parseInt(e);
				},

				etape1IsValid: function () {
					let estValide = true;


					if (true) {
						this.error.publishDate = null;

						let a = this.saisie.publishDate.start;
						let b = this.saisie.publishDate.end;
						if (!a || !b) this.error.publishDate = "Date required";

						if (!DateHelper.isValid(a) || !DateHelper.isValid(b)) this.error.publishDate = "Invalid date";

						//if(a<=DateHelper.now() || b<=DateHelper.now())  this.error.publishDate = 'Date start must be after now.';
						if (a >= b) this.error.publishDate = 'Date start must be before date end.';
					}


					this.error.user = null;

					//
					try { THIS.verifBloc(THIS.c$("._etape1")) } catch (e) { }
					estValide = (this.error.user == null && this.error.publishDate == null && THIS.formErreurs.length == 0);

					/* console.log(`etape ${this.etape} est valide ${estValide}`); */
					return estValide;
				},
				fin: function () {
					THIS.fin();
				},

				/* Etape 1*/
				isNewGroupe: function (user1, user2) {
					if (!user1) return true;
					return !(user1.groupe == user2.groupe);

				},
				majResultSearch: function () {
					let indexSearch = [];
					indexSearch = this.searchUser.result.map(e => { return e.item.k; });
					for (let user of this.codification.users) {
						user.inSearch = (indexSearch.indexOf(user.k) > -1);
					}
				},



				/* Etape 2 */
				loadEtape2: function () {
					/* console.log("Initialisation étape 2"); */
				},
				etape2IsValid: function () {
					let estValide = true;
					//for (const filter of this.codification.filters) {
					//	for (const fl of filter.rows) estValide = (estValide || fl.val);
					//}
					//this.selectFiltersError = (!estValide) ? 'No filter selected ' : null;
					//

					return estValide;
				},
				libelleFilter(filter) {
					if (filter.label) return filter.label();
					return filter.v;
				},
				selectFilter: async function (filter) {

					const thisView = this;
					if (filter.beforeShow) {
						await filter.beforeShow(filter.param, thisView.saisie);
					}
					if (filter.is) {
						filter.param.estInitialise = false;
						this.composantfilter = {
							is: filter.is,
							param: filter.param,
						};
					} else {
						window.alert("filtre inconnu : " + filter.k)
					}
				},

				/* Etape 3 */
				loadEtape3: async function () {

					let data = { rows: [] };
					//data = await THIS.rest("b2b.linelist.preview", {}, this.saisie);
					//
					for (const row of data.rows) {
						row.img = (row.img) ? "download/product/" + row.img.replace("*", "T") : "";
					}
					this.refs = data; // refs;
					this.updateCountChecked();
					//
					const optionsProduct = { includeScore: false, minMatchCharLength: 2, threshold: 0.2, keys: ['reference', 'v'] };
					this.fuseProduct = new Fuse(this.refs.rows, optionsProduct);
				},
				updateCountChecked: function () {
					let count = 0;
					if (this.onlyRefsChecked) count = this.refsChecked.length;
					else count = this.refs.rows.length - this.refsChecked.length;
					this.totalRefsSelected = count;
				},
				getCssProduct: function (ref) {
					let css = "";
					// (refsChecked.indexOf(ref.ref)>=0)? (onlyRefsChecked)? 'table-light' :'opacity-25'  : '' "
					if (this.refsChecked.indexOf(ref.ref) >= 0 && this.onlyRefsChecked) css = 'table-light ';
					if (this.refsChecked.indexOf(ref.ref) >= 0 && !this.onlyRefsChecked) css = 'opacity-25 ';
					if (ref.inSearch) css = css + " text-primary";
					return css
				},
				majResultProduct: function () {
					let indexSearch = [];
					indexSearch = this.searchProduct.result.map(e => { return e.item.reference; });
					for (let ref of this.refs.rows) {
						ref.inSearch = (indexSearch.indexOf(ref.reference) > -1);
					}
				},

				etape3IsValid() {
					return true;
				},

				etape4IsValid() {
					return true;
				},

				/* Etape 4 */
				loadEtape4() {
				},
				async save() {
					const result = await THIS.rest("b2b.linelist.save", {env:env}, this.saisie);
					if (result.ok) THIS.fin();
				},

			},
			watch: {
				"searchUser.k"(val) {
					this.searchUser.result = fuse.search(val);
					this.majResultSearch();
				},

				"searchFiltre.k"(val) {
					let searchResult = this.fuseFiltre.search(val);

					if (this.filtersSelected.k) {
						let indexSearch = searchResult.map(e => {
							return e.item.k;
						});
						this.filtersSelected.rows.map(u => {
							u.inSearch = (indexSearch.indexOf(u.k) > -1);
						})
					}
				},
				"searchProduct.k"(val) {
					this.searchProduct.result = this.fuseProduct.search(val);
					this.majResultProduct();

				},
				"saisie.regroupment.level1"(val) {
					if (this.saisie.regroupment.level1?.k == this.saisie.regroupment.level2?.k) this.saisie.regroupment.level2 = "";
				},
				"saisie.regroupment.level2"(val) {
					if (this.saisie.regroupment.level1?.k == this.saisie.regroupment.level2?.k) this.saisie.regroupment.level1 = "";
				},
				"etape"(val) {
					/* console.log("changement d'étape") */
					if (this.etape == 2 && this.loadEtape2) this.loadEtape2();

					if (this.etape == 3) this.loadEtape3();
				},
				"refsChecked"(val) {
					this.updateCountChecked();
				},
				"onlyRefsChecked"() {
					this.updateCountChecked();
				}

			},
			mounted() {
				/* Si un ID est présent dans le hash, alors on est en mode édition. */
				if (this.saisie._id) {
					this.etape = -1;
					this.tocChange();
				} else {
					this.isEdition = true
				}
			}
		});

		app.mount(THIS.c$('._vueChargement')[0]);

		THIS.c$("._toclose, ._toopen").on("click", function (e) {
			let ouvrir = $(this).hasClass("_toopen");
			let g = $(this).attr("data-groupe");
			THIS.c$("._user[data-groupe='" + g + "']").toggle(ouvrir);

			THIS.c$("._toclose[data-groupe='" + g + "']").toggle(ouvrir);
			THIS.c$("._toopen[data-groupe='" + g + "']").toggle((!ouvrir));
		})


		// const toggles = document.querySelectorAll('._inputMask');
		// let options = { alias: "datetime", inputFormat: "dd/mm/yyyy", placeholder: "__/__/____" }
		// Inputmask(options).mask(toggles);

	},
	loader: function (echangeur) {

	},
});

export default {
	linelistEdit: { js: jsNew, html: htmlNew }
};
